import { useAuth } from "../../context/AuthContext";
import logo from "../../assets/logo-gold.svg";

function NavBar() {
  const { user, logout } = useAuth();

  return (
    <header className='sticky top-0 z-45 shadow-md'>
      {/* Barra informativa */}
      <div className='bg-amco-gold lg:h-[42px] flex items-center md:h-[42px] xs:h-[25px] h-[25px]'>
        <div className='max-w-screen-xl mx-auto px-4'>
          <a
            className='text-white font-bold text-[12px] block text-center lg:text-[15px] xs:text-[12px]'
            href='https://amco.pt/wp-content/uploads/2025/05/AMCO-Intermediarios-Credito_n759.pdf'
            target='_blank'
            rel='noopener noreferrer'
          >
            Intermediário de Crédito nº759
          </a>
        </div>
      </div>

      {/* Barra principal */}
      <div className='bg-white lg:h-[110px] md:h-[110px] h-[60px]'>
        <div className='max-w-screen-xl mx-auto w-full px-4 xs:px-8 flex items-center justify-between h-full'>
          {/* Placeholder div */}
          <div className='w-[182px] md:w-[182px] xs:w-[102px]' />

          {/* Centro: logotipo */}
          <img
            className='h-[40px] lg:h-[90px] w-auto md:h-[90px] xs:h-[40px] xs:w-auto'
            src={logo}
            alt='AMCO | Intermediários de Crédito'
          />

          {/* Lado direito: selos */}
          <div className='flex items-center gap-2 lg:w-[182px] md:w-[182px] xs:w-[102px] w-[182px] justify-end'>
            <img
              className='h-[60px] md:h-[74px] sm:block xs:hidden hidden'
              src='https://amco.pt/wp-content/uploads/2025/04/LogoP5E2025_Intermediacao-de-Credito-fundo-claro-1.webp'
              alt='Selo Intermediação'
            />
            <img
              className='h-[60px] md:h-[74px] sm:block xs:hidden hidden'
              src='https://amco.pt/wp-content/uploads/2025/04/BOA-ESCOLHA-2.webp'
              alt='Selo Boa Escolha'
            />
          </div>
        </div>
      </div>
    </header>
  );
}

export default NavBar;
